export const TERMS_OF_SERVICE_URL = "https://www.kahun.com/terms-of-service";
export const PRIVACY_POLICY_URL = "https://www.kahun.com/privacy-policy";
export const COOKIE_SETTINGS_URL = "https://www.kahun.com/cookie-settings";
export const CONFIRM_PROFESSIONAL_KEY = "confirmProfessional";
export const USER_ROLE_KEY = "userRole";
export const ANONYMOUS_SESSION_KEY = "anonymousSession";
export const USER_ROLES = [
  "Physician",
  "Medical student",
  "Resident",
  "Specialist",
  "Nurse practitioner",
  "Physician assistant",
  "Other",
];

export const ASSESSMENT_EXCHANGE_INDEX = -102;
export const PLAN_EXCHANGE_INDEX = -103;
